import { gql } from '@apollo/client'

export const UPDATE_USER_VEHICLE = gql`
    mutation update_user_vehicle($request: UpdateUserVehicleRequest!) {
        update_user_vehicle(request: $request) {
            success
        }
    }
`
// $name: String!, $manufacturer: String!, $model: String!
